import { Button, Card, CardContent } from '@cortex/ui';
import { ArrowLeft, FileQuestion, Home } from 'lucide-react';
import { useNavigate } from 'react-router';

export function NotFound() {
  const navigate = useNavigate();
  return (
    <div
      className="p-6 lg:p-8 bg-gradient-to-br from-slate-50 to-blue-50/30 min-h-screen flex items-center justify-center"
      data-testid="not-found"
    >
      <Card className="border-slate-200 bg-white/80 backdrop-blur-sm max-w-md w-full">
        <CardContent className="py-12 text-center">
          <FileQuestion className="w-16 h-16 mx-auto mb-6 text-slate-300" />
          <h1 className="text-2xl font-bold text-slate-900 mb-2">Page Not Found</h1>
          <p className="text-slate-500 mb-6">The page you're looking for doesn't exist or has been moved.</p>
          <div className="flex items-center justify-center gap-3">
            <Button variant="outline" onClick={() => navigate(-1)}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
            <Button onClick={() => navigate('/')}>
              <Home className="w-4 h-4 mr-2" />
              Home
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
